<template>
  <div class="mcontent">
    <layout type="T_B"
      v-if="root.device!='phone'"
      :class="[root.device=='ipad'&&'mipad']"
    >
      <layout
        class="T"
        type="L_R"
        flex='1.3'
      >
        <wrapper flex='1'>
          <cusbox txt="在产图样说明（模拟）">
            <layout type="T_B">
              <div style="display:flex;justify-content: center;align-items:center;">
              <div style="height:2vw;width:8vw;">            
                 <van-swipe :show-indicators="false" :autoplay="6000" >
                      <van-swipe-item >                  
                        <span style="margin:0 1vw">105R6E27D</span>                     
                      </van-swipe-item>
                      <van-swipe-item >                        
                        <span style="margin:0 1vw">105R6E27D2</span>                      
                      </van-swipe-item>                      
                    </van-swipe>
              </div>
              </div>
              <div flex='8'>
                <cell type="top">
                  <div style="width:28vw;height:80%;">
                    <van-swipe :autoplay="6000" :show-indicators="false">
                      <van-swipe-item >
                        <img src="@/assets/test.png" style="width:100%;height:95%;" />
                      </van-swipe-item>
                      <van-swipe-item >
                        <img src="@/assets/t1.png" style="width:100%;height:95%;" />
                      </van-swipe-item>
                    </van-swipe>

                  </div>
                </cell>
              </div>
            </layout>
          </cusbox>
        </wrapper>

        <wrapper flex='2'>
          <cusbox txt="实时排产计划（模拟）">
            <layout
              type="T_B"
              flex="1"
            >
              <cell>
                <div style="background:#181E45;width:70%;height:8vw;padding:1vw 0;">
                <layout
                  type="T_B"
                  flex="1" >
                  <div style="display:flex;color:#BFC7FD;font-size:1.3vw;">
                    <cell flex="1"><div>当前总排场计划</div></cell>
                    <cell flex="1"><div>今日排产计划</div></cell>
                    <cell flex="1"><div>异常逾期</div></cell>
                  </div>
                </layout>
                <layout
                  type="T_B"
                  flex="1"> 
                   <div style="display:flex;padding:1vw 0;">
                    <cell flex="1">
                      <layout type="L_R" flex="1" style="margin-left:1vw;">
                        <cell flex="1" type="">
                        <img
                          src='@/assets/i5.png'
                          style="width:100%;height:100%;"
                        >
                        </cell>
                      </layout>
                      <layout type="L_R" flex="5">
                        <layout type="T_B">
                          <cell flex="1" style="justify-content: left;">
                            <div class="txt1">款数</div>
                          </cell>
                           <cell flex="1" style="justify-content: left;">
                          <div class="txt2">232</div>
                          </cell>
                        </layout>
                        <layout type="T_B" style="margin-left:1vw;">
                           <cell flex="1" ><div class="txt1">件数</div>
                           </cell>
                            <cell flex="1" ><div class="txt2">23209</div>
                            </cell></layout>
                      </layout>
                    </cell>
                    <cell flex="1">
                      <layout type="L_R" flex="1" style="margin-left:1vw;">
                        <cell flex="1" type="">
                        <img
                          src='@/assets/i6.png'
                          style="width:100%;height:100%"
                        >
                        </cell>
                      </layout>
                      <layout type="L_R" flex="5">
                        <layout type="T_B">
                          <cell flex="1" style="justify-content: left;">
                          <div class="txt1">款数</div>
                          </cell>
                           <cell flex="1" style="justify-content: left;">
                          <div class="txt2">232</div>
                          </cell>
                        </layout>
                        <layout type="T_B" style="margin-left:1vw;">
                           <cell flex="1"><div class="txt1">件数</div>
                           </cell>
                            <cell flex="1" ><div class="txt2">23209</div>
                            </cell></layout>
                      </layout>
                    </cell>
                    <cell flex="1">
                      <div flex="1"></div>
                      <layout type="L_R" flex="1" style="margin-left:1vw;">
                      <cell flex="1">
                         <img
                          src='@/assets/i6.png'
                          style="width:100%;height:100%"
                        >
                      </cell>
                      </layout>
                      <layout type="L_R" flex="4">
                       
                        <layout type="T_B" >
                           <cell flex="1" style="justify-content: left;margin: 0 1vw;"><div class="txt1">款数</div>
                           </cell>
                            <cell flex="1" style="justify-content: left;margin:0 1vw"><div class="txt2">232</div>
                            </cell></layout>
                      </layout>
                    </cell>
                  </div>
                </layout>
              </div>
              </cell>
            </layout>
            <layout
              type="T_B"
              flex="2"
            >
              <layout type="L_R">
                <layout type="L_R" flex="1">
                  <layout type="T_B">
                    <layout type="T_B" flex="1">
                      <cell class="txt1"><span>车缝作业</span></cell>
                    </layout>
                    <layout type="T_B" flex="5">
                       <cell>
                          <itemlist style="width: 86%;"
                            :count='5'
                            :columns='columns1'
                            :data='data1'
                          />
                       </cell>
                    </layout>
                 </layout>
              </layout>
              <layout type="L_R"  flex="1">
                <layout type="T_B">
                    <layout type="T_B" flex="1">
                      <cell class="txt1"><span>裁剪作业</span></cell>
                    </layout>
                    <layout type="T_B" flex="5">
                       <cell >
                          <itemlist style="width: 86%;"
                            :count='5'
                            :columns='columns2'
                            :data='data2'
                          />
                       </cell>
                    </layout>
                 </layout>
              </layout>
              </layout>
           
            </layout>
          </cusbox>
        </wrapper>
      </layout>

      <layout
        class="T"
        type="L_R"
        flex='1'
      >
        <wrapper>
          <cusbox txt="车间生产单据监控（模拟）">
            <itemlist
              :count='5'
              :columns='columns3'
              :data='data3'
            >
            <template
                slot='today_situationhead'
                slot-scope="{data}"
              >
                <!-- {{data.today_situation}} -->
                <div><span>今日完成情况</span></div>
                 <cell>
                   <div style="display:flex;align-items: center;">
                  <div class="order_head" style="background:#02B5F8;"></div>
                  <div style="width:0.5vw;"></div>
                  <div >已入库</div>
                  <div style="width:1vw;"></div>
                  <div class="order_head" style="background:#6648FF;"></div>
                  <div style="width:0.5vw;"></div>
                  <div>生产中</div>
                  <div style="width:1vw;"></div>
                  <div class="order_head" style="background:#377DFF;"></div>
                  <div style="width:0.5vw;"></div>
                  <div >剩余</div>
                </div>
                 </cell>
               
              </template>
              <template
                slot='today_situation'
                slot-scope="{data}"
              >         
                <div style="display:flex;height:0.5vw;">
                  <div style="background:#02B5F8;" :style="{'flex':data.today_situation.warehousing}"></div>
                  <div style="background:#6648FF;" :style="{'flex':data.today_situation.warehousing}"></div>
                  <div style="background:#377DFF;border-radius:0 1vw 1vw 0;" :style="{'flex':data.today_situation.warehousing}"></div>
                  <div style="flex:10"></div>
                </div>
              </template>
            </itemlist>
          </cusbox>
        </wrapper>
      </layout>
    </layout>

         <mobile class="device_phone ppd notransform" v-else>
              <div class="moblieline hauto">
                          <cusbox txt="在产图样说明（模拟）">
            <layout type="T_B">
              <div class="tab">
              <div  class="swp1">            
                 <van-swipe :show-indicators="false" :autoplay="6000" >
                      <van-swipe-item >                     
                        <span style="margin:0 1vw">105R6E27D</span>                        
                      </van-swipe-item>
                      <van-swipe-item >                        
                        <span style="margin:0 1vw">105R6E27D2</span>                       
                      </van-swipe-item>                      
                    </van-swipe>
              </div>
              </div>
              <div flex='1'> 
                <cell type="top">
                  <div class="swp2">
                    <van-swipe :autoplay="6000" :show-indicators="false">
                      <van-swipe-item >
                        <img src="@/assets/test.png" style="width:100%;height:95%;" />
                      </van-swipe-item>
                      <van-swipe-item >
                        <img src="@/assets/t1.png" style="width:100%;height:95%;" />
                      </van-swipe-item>
                    </van-swipe>

                  </div>
                </cell>
              </div>
            </layout>
          </cusbox>
              </div>
               <div class="moblieline h550">
                     <cusbox txt="实时排产计划（模拟）">
            <layout
              type="T_B"
              style="flex:none;margin-top:20px;"
            >            
              <cell>
                <div style="background:#181E45;width:90%;padding:1vw 0;">
                <layout
                  type="T_B"
                  flex="1" >
                  <div style="display:flex;color:#BFC7FD;font-size:1.3vw;">
                    <cell flex="1"><div>当前总排场计划</div></cell>
                    <cell flex="1"><div>今日排产计划</div></cell>
                    <cell flex="1"><div>异常逾期</div></cell>
                  </div>
                </layout>
                <layout
                  type="T_B"
                  flex="1"> 
                   <div style="display:flex;padding:1vw 0;">
                    <cell flex="1">
                      <layout type="L_R" flex="1" style="margin-left:1vw;">
                        <cell flex="1" type="">
                        <img
                          src='@/assets/i5.png'
                          style="width:100%;height:100%;"
                        >
                        </cell>
                      </layout>
                      <layout type="L_R" flex="5">
                        <layout type="T_B">
                          <cell flex="1" style="justify-content: left;">
                            <div class="txt1">款数</div>
                          </cell>
                           <cell flex="1" style="justify-content: left;">
                          <div class="txt2">232</div>
                          </cell>
                        </layout>
                        <layout type="T_B" style="margin-left:1vw;">
                           <cell flex="1" ><div class="txt1">件数</div>
                           </cell>
                            <cell flex="1" ><div class="txt2">23209</div>
                            </cell></layout>
                      </layout>
                    </cell>
                    <cell flex="1">
                      <layout type="L_R" flex="1" style="margin-left:1vw;">
                        <cell flex="1" type="">
                        <img
                          src='@/assets/i6.png'
                          style="width:100%;height:100%"
                        >
                        </cell>
                      </layout>
                      <layout type="L_R" flex="5">
                        <layout type="T_B">
                          <cell flex="1" style="justify-content: left;">
                          <div class="txt1">款数</div>
                          </cell>
                           <cell flex="1" style="justify-content: left;">
                          <div class="txt2">232</div>
                          </cell>
                        </layout>
                        <layout type="T_B" style="margin-left:1vw;">
                           <cell flex="1"><div class="txt1">件数</div>
                           </cell>
                            <cell flex="1" ><div class="txt2">23209</div>
                            </cell></layout>
                      </layout>
                    </cell>
                    <cell flex="1">
                      <div flex="1"></div>
                      <layout type="L_R" flex="1" style="margin-left:1vw;">
                      <cell flex="1">
                         <img
                          src='@/assets/i6.png'
                          style="width:100%;height:100%"
                        >
                      </cell>
                      </layout>
                      <layout type="L_R" flex="4">
                       
                        <layout type="T_B" >
                           <cell flex="1" style="justify-content: left;margin: 0 1vw;"><div class="txt1">款数</div>
                           </cell>
                            <cell flex="1" style="justify-content: left;margin:0 1vw"><div class="txt2">232</div>
                            </cell></layout>
                      </layout>
                    </cell>
                  </div>
                </layout>
              </div>
              </cell>
            </layout>
            <layout
              type="T_B"
              flex="2"
            >         
                  <layout type="T_B">
                    <layout type="T_B" flex="1">
                      <cell class="txt1"><span>车缝作业</span></cell>
                    </layout>
                    <layout type="T_B" flex="5">
                       <cell>
                          <itemlist style="width: 86%;"
                            :count='5'
                            :columns='columns1'
                            :data='data1'
                          />
                       </cell>
                    </layout>                 
             
                    <layout type="T_B" flex="1">
                      <cell class="txt1"><span>裁剪作业</span></cell>
                    </layout>
                    <layout type="T_B" flex="5">
                       <cell >
                          <itemlist style="width: 86%;"
                            :count='5'
                            :columns='columns2'
                            :data='data2'
                          />
                       </cell>
                    </layout>
               
              </layout>
           
            </layout>

          </cusbox>
               </div>
               <div  class="moblieline">
                   <cusbox txt="车间生产单据监控（模拟）">
            <itemlist
              :count='5'
              :columns='cols_1'
              :data='data3'
            >
            <template
                slot='today_situationhead'
                slot-scope="{data}"
              >
                <!-- {{data.today_situation}} -->
                <div><span>今日完成情况</span></div>
                 <cell>
                   <div style="display:flex;align-items: center;">
                  <div class="order_head" style="background:#02B5F8;"></div>
                  <div style="width:0.5vw;"></div>
                  <div >已入库</div>
                  <div style="width:1vw;"></div>
                  <div class="order_head" style="background:#6648FF;"></div>
                  <div style="width:0.5vw;"></div>
                  <div>生产中</div>
                  <div style="width:1vw;"></div>
                  <div class="order_head" style="background:#377DFF;"></div>
                  <div style="width:0.5vw;"></div>
                  <div >剩余</div>
                </div>
                 </cell>
               
              </template>
              <template
                slot='today_situation'
                slot-scope="{data}"
              >         
                <div style="display:flex;height:5px;">
                  <div style="background:#02B5F8;" :style="{'flex':data.today_situation.warehousing}"></div>
                  <div style="background:#6648FF;" :style="{'flex':data.today_situation.warehousing}"></div>
                  <div style="background:#377DFF;border-radius:0 1vw 1vw 0;" :style="{'flex':data.today_situation.warehousing}"></div>
                  <div style="flex:10"></div>
                </div>
              </template>
            </itemlist>
          </cusbox>
               </div>
         </mobile>
  </div>

</template>
<script>
import layout from "@/components/cuscom/layout.vue";
import wrapper from "@/components/cuscom/wrapper.vue";
import cusbox from "@/components/vip/cusbox";
import itemlist from "@/components/cuscom/itemlist";
import cell from "@/components/cuscom/cell.vue";
import {cols_1,cols_2} from "./device/phone_column.js"
export default {
  components: { layout, wrapper, cusbox, itemlist, cell },
   inject:['root'],
  data() {
    return {
     cols_1,
      api:this.$apis["digitalproduction_2"],
      columns1: [
        {
          title: "货号",
          key: "goods_no",
          align: "center",
          width:'8vw',
        },
        {
          title: "数量",
          key: "number",
          align: "center",
        },
        {
          title: "线组/车间",
          key: "thread",
          align: "center",
        },
        {
          title: "货期",
          key: "period",
          align: "center",
        },
        {
          title: "状态",
          key: "status",
          align: "center",
        }
      ],
      columns2: [
        {
          title: "货号",
          key: "goods_no",
          align: "center",
           width:'8vw',
        },
        {
          title: "数量",
          key: "number",
          align: "center",
        },
        {
          title: "线组/车间",
          key: "thread",
          align: "center",
        },
        {
          title: "货期",
          key: "period",
          align: "center",
        },
        {
          title: "状态",
          key: "status",
          align: "center",
        }
      ],
      columns3: [
        {
          title: "生产单状态",
          key: "order_status",
          align: "center"
        },
        {
          title: "计划单号",
          key: "order_no",
          align: "center",
           width:'10vw',
        },
        {
          title: "款号",
          key: "goods_no",
          align: "center"
        },
        {
          title: "组别/车间",
          key: "group",
          align: "center"
        },
        {
          title: "品类",
          key: "category",
          align: "center"
        },
        {
          title: "大仓库存",
          key: "warehouse",
          align: "center"
        },
        {
          title: "店铺库存",
          key: "shop_warehouse",
          align: "center"
        },
        {
          title: "交货日期",
          key: "delivery",
          align: "center"
        },
        {
          title: "剩余天数",
          key: "days",
          align: "center"
        },
        {
          title: "生产单总量",
          key: "order_number",
          align: "center"
        },
        {
          title: "累计入库",
          key: "cumulative",
          align: "center"
        },
        {
          title: "今日计划量",
          key: "today_number",
          align: "center"
        },
        {
          title: "今日已入库",
          key: "today_warehousing",
          align: "center"
        },
        {
          title: "今日完成情况",
          key: "today_situation",
          align: "center",
          slot: "today_situation",
          slot_head: "today_situationhead",
          width: "15vw"
        }
      ],
      data1: [],
      data2: [],
      data3: [],
       images: [
        'https://img.yzcdn.cn/vant/apple-1.jpg',
        'https://img.yzcdn.cn/vant/apple-2.jpg',
      ],
    };
  },
  mounted() {
   
    this.api.get1().then(res=>{
      this.data3=res.data.list
    })
    this.api.get2().then(res=>{
     
      this.data1=res.data.list
    })
     this.api.get2().then(res=>{
     this.data2=res.data.list
    })
  }
};
</script>
<style lang="scss" scope>
@import './device/phone.scss';
   .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    text-align: center;
    background-color: #39a9ed;
  }
.mcontent {
  color: #fff;
  height: 100%;
  display: flex;
  .T {
    // border: 1px solid red;
  }
  .txt1{
    font-size: 1vw;
    color: #BFC7FD;
  }
   .txt2{
    font-size: 2vw;
  }
  .order_head{
    width:0.5vw;height:0.5vw;
  }
}
</style>



